import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  followingsData: [],
  followersData: [],
  followingsPageNumber: 1,
  followersPageNumber: 1,
  followLoading: true,
};

const followerFollowingSlice = createSlice({
  name: "followerFollowing",
  initialState: initialState,
  reducers: {
    followingsDataReducer(state, action) {},
    followingsDataReducerReset() {
      return initialState;
    },
  },
});

export const { followingsDataReducerReset } = followerFollowingSlice.actions;
export default followerFollowingSlice.reducer;
